export default {
  vendorName: {
    type: 'string',
    required: true,
  },
  country: {
    type: 'string',
    required: true,
  },
  taxRegistrationNumber: {
    type: 'string',
    maxSize: 12,
    required: {
      value: true,
      when: {
        $country: {
          in: ['Belarus', 'Poland'],
        },
      },
    },
  },
  costCenterId: {
    type: 'string',
    required: true,
  },
  isDataProcessor: {
    type: 'boolean',
    required: false,
  },
  isCompliant: {
    type: 'string',
    required: true,
  },
  isAutoApproved: {
    type: 'boolean',
    required: false,
  },
  purpose: {
    type: 'string',
    required: true,
  },

  phoneNumber: {
    type: 'string',
    required: false,
    phone: {
      value: true,
      message: 'Please enter phone number in format xxxxxxxxxxxx, max. 15 characters',
    },
  },
  email: {
    type: 'string',
    email: true,
    required: false,
  },
  contacts: {
    type: 'array',
    required: false,
    maxSize: 3,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        name: {
          type: 'string',
          required: true,
        },
        phoneNumber: {
          type: 'string',
          required: false,
          phone: {
            value: true,
            message: 'Please enter phone number in format xxxxxxxxxxxx, max. 15 characters',
          },
        },
        email: {
          type: 'string',
          email: true,
          required: false,
        },
      },
    },
  },

  agreementDetails: {
    type: 'object',
    _divisible: false,
    properties: {
      legalEntity: {
        type: 'enum',
        required: true,
      },
    },
  },
};
